import { FC } from "react";
import { WrapperProps } from "../../../lib/types/shared/reactInherited";

const G_Div: FC<WrapperProps> = ({ children, ...rest }) => {
  return <div {...rest}>{children}</div>;
};

export default G_Div;
